import React from 'react';
import { Routes, Route } from 'react-router-dom';

import env from '~/commons/config/env';

import RoutesAuth from './RoutesAuth';
import PageView from '../pages/PageView';
import PageHome from '../pages/PageHome';
import PageTopics from '../pages/PageTopics';
import RoutesGame from './RoutesGame';
import PageLinks from '../pages/PageLinks';
import PageMascots from '../pages/PageMascots';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<PageHome />} />
    <Route path="/topics" element={<PageTopics />} />
    <Route path="/topics/:topic" element={<PageTopics />} />
    <Route path="/mascots" element={<PageMascots />} />

    <Route path="/links" element={<PageLinks />} />
    {!env.user && (
      <Route path="/auth/*" element={<RoutesAuth />} />
    )}
    {env.user?.role === 'client' && (
      <Route path="/game/*" element={<RoutesGame />} />
    )}
    <Route path="/*" element={<PageView />} />
    ´
  </Routes>
);

export default AppRoutes;
